import { clubOrder } from "../../config/ClubInfo";
import { Target } from "../../store/Session/SessionModel";
import _ from "lodash";
import "./style.css";
interface Props {
  target: Target;
}
const StackClubIcons = ({ target }: Props) => {
  if (!target.shots) {
    return <></>;
  }
  const clubGroups = _.groupBy(target.shots, "clubIcon");
  const clubNicknames = Object.keys(clubGroups);
  let clubData: any = [];
  clubNicknames.map((clubIcon) =>
    clubData.push({
      clubIcon,
      clubColor: clubGroups[clubIcon][0].clubColor,
      clubType: clubGroups[clubIcon][0].clubType,
      clubName: clubGroups[clubIcon][0].clubName
    })
  );
  clubData = clubData.sort((a: any, b: any) => {
    return clubOrder.indexOf(a.clubType) - clubOrder.indexOf(b.clubType);
  });
  if (clubData.length === 0) {
    return <></>;
  }
  const clubName = clubData.length > 1 ? "Mixed" : clubData[0].clubName;
  return (
    <div className="stacked-club">
      <div className="stacked-label">
        {clubData.map((club: any, index: number) => (
          <div
            key={index}
            className="circle toggle-club"
            style={{ left: `${index * 15}px`, zIndex: index + 1 }}
          >
            <div
              className={`circle-club-color`}
              style={{ backgroundColor: club.clubColor }}
            >
              <div className="club-icon">{club.clubIcon}</div>
            </div>
          </div>
        ))}
        <div
          className="circle club-nickname"
          style={{
            left: `${clubData.length * 15 + 20}px`,
            zIndex: clubData.length + 1
          }}
        >
          {clubName}
        </div>
      </div>
    </div>
  );
};
export default StackClubIcons;
